import axios from 'axios';

const SERVER_URL = process.env.REACT_APP_ADMIN_BASE_URL;

const instance = axios.create({
    baseURL: SERVER_URL
});

export default instance;
